/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .modal__footer-action[_ngcontent-%COMP%]{padding-bottom:1.5rem}[_nghost-%COMP%]   .modal__footer-action[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]:first-child{margin-right:0;margin-top:.5rem;margin-bottom:1.5rem}@media (min-width:600px){[_nghost-%COMP%]   .modal__footer-action[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]:first-child{margin-right:1.5rem;margin-bottom:0;margin-top:0}}"];
export { styles as styles };
